// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgViewHide24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_18342_280266)">
					<path d="M12.2702 13.9887H12.2918C15.4486 13.9887 18.3999 12.3887 21.0702 9.24278C21.3404 8.92927 21.2972 8.44278 20.9837 8.17251C20.6594 7.90224 20.1837 7.94548 19.9134 8.259C17.5459 11.0482 14.9837 12.4644 12.2918 12.4644C7.68639 12.4644 4.11882 8.31305 4.08639 8.26981C3.81612 7.9563 3.34044 7.91305 3.01612 8.18332C2.6918 8.45359 2.65936 8.92927 2.91882 9.25359C3.08098 9.44819 6.95126 13.9887 12.2594 13.9995L12.2702 13.9887Z" />
					<path d="M11.9999 15.0811C11.5783 15.0811 11.2432 15.4162 11.2432 15.8378V17.9675C11.2432 18.3892 11.5783 18.7243 11.9999 18.7243C12.4215 18.7243 12.7567 18.3892 12.7567 17.9675V15.8378C12.7567 15.4162 12.4215 15.0811 11.9999 15.0811Z" />
					<path d="M4.72975 13.6916L3.21623 15.1943C2.92434 15.4862 2.92434 15.9727 3.21623 16.2645C3.36758 16.4159 3.56218 16.4916 3.75677 16.4916C3.95137 16.4916 4.14596 16.4159 4.29731 16.2645L5.80002 14.7618C6.09191 14.47 6.09191 13.9835 5.80002 13.6916C5.50813 13.3997 5.02164 13.3997 4.72975 13.6916Z" />
					<path d="M20.7838 15.1943L19.2811 13.6916C18.9892 13.3997 18.5028 13.3997 18.2109 13.6916C17.919 13.9835 17.919 14.47 18.2109 14.7618L19.7136 16.2645C19.8649 16.4159 20.0595 16.4916 20.2541 16.4916C20.4487 16.4916 20.6433 16.4159 20.7946 16.2645C21.0865 15.9727 21.0865 15.4862 20.7946 15.1943H20.7838Z" />
				</g>
				<defs>
					<clipPath id="clip0_18342_280266">
						<rect width={20} height={10.7243} transform="translate(2 8)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgViewHide24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgViewHide24;
